function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getHighlightColor } from "../helpers/highlightColor";
import { SDropdown } from "../../../SDropdown";
import { SFlex } from "../../../components";
import tw from "tailwind-styled-components";
import React from "react";
import STooltip from "../../../Tooltip";
import useChildIndex from "../../../hooks/useChildIndex";
export const renderIcon = ({ icon, label, value })=>{
    console.log(`CSSColorPicker -renderIcon `, icon, label);
    if (typeof icon !== "undefined") {
        if (typeof icon === "function") {
            return icon({
                value
            });
        }
        return icon;
    }
    return label;
};
export const CSSEnum = ({ props, onSelectOption, enumOptions })=>{
    console.log(`CSSEnum - enumOptions`, enumOptions, props);
    const { options, option } = enumOptions;
    const orderedOptions = Object.entries(options).map(([value, rest])=>_object_spread({
            value
        }, rest));
    const shouldUseDropdown = orderedOptions.length > 6 || orderedOptions.some((x)=>!x.icon);
    if (!shouldUseDropdown) {
        var _props_value;
        return /*#__PURE__*/ _jsx(CSSEnumButtons, {
            props: props,
            selectedOption: (props === null || props === void 0 ? void 0 : (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.value) || undefined,
            onSelectOption: onSelectOption,
            orderedOptions: orderedOptions
        });
    } else {
        var _props_value1;
        return /*#__PURE__*/ _jsx(CSSEnumDropdown, {
            props: props,
            selectedOption: (props === null || props === void 0 ? void 0 : (_props_value1 = props.value) === null || _props_value1 === void 0 ? void 0 : _props_value1.value) || undefined,
            onSelectOption: onSelectOption,
            orderedOptions: orderedOptions
        });
    }
};
const CSSEnumDropdown = ({ selectedOption, orderedOptions, onSelectOption, props })=>{
    const literalValueOption = orderedOptions.find((x)=>x.value === selectedOption);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            style: {},
            className: `w-full !h-[26px] !border${(()=>{
                if (!selectedOption) {
                    return "!border-[#4A4F55]";
                }
                if (props.isDynamic) {
                    return "!border-purple-500";
                }
                return "!border-brand-primary border-opacity-10";
            })()} rounded-md`,
            children: /*#__PURE__*/ _jsx(SDropdown, {
                disabled: props.readOnly,
                isUnstyledItems: true,
                position: "left",
                display: "relative",
                className: "!text-opacity-100",
                elements: orderedOptions.map(({ value, label, icon })=>{
                    return /*#__PURE__*/ _jsx(SDropdown.Item, {
                        onClick: ()=>{
                            onSelectOption(value);
                        },
                        $size: "sm",
                        children: renderIcon({
                            icon,
                            label,
                            value
                        })
                    }, value);
                }),
                children: /*#__PURE__*/ _jsx(SDropdown.Button, {
                    $small: true,
                    $full: true,
                    children: literalValueOption ? renderIcon(_object_spread_props(_object_spread({}, literalValueOption), {
                        value: selectedOption || literalValueOption.label
                    })) : "-"
                })
            })
        })
    });
};
const highlightColorToSelection = (highlightColor)=>{
    if (highlightColor === "brand-primary") {
        return "literal";
    }
    if (highlightColor === "purple-500") {
        return "conditional";
    }
    return undefined;
};
const PropertyButtonContainer = tw.div`
  flex
  justify-center
  items-center
  grow
  border
  border-white
  border-opacity-10
  rounded-md
  py-[6px]
  text-xs
  cursor-pointer

  ${({ $selection })=>{
    return $selection ? $selection === "literal" ? "bg-brand-primary bg-opacity-10 text-brand-primary hover:border-opacity-20" : $selection === "conditional" ? "bg-purple-500 bg-opacity-10 text-purple-500 hover:border-opacity-20" : "bg-grayscale-light hover:border-opacity-30 text-white" : "bg-grayscale-light hover:border-opacity-30 text-white";
}}
`;
const PropertyButton = ({ icon, label, value, onClick, selection, showTooltip = true, grow = true })=>{
    const ref = React.useRef(null);
    const { isFirst, isLast } = useChildIndex(ref) || {};
    return /*#__PURE__*/ _jsxs("div", {
        className: grow ? "grow" : "",
        ref: ref,
        children: [
            showTooltip && /*#__PURE__*/ _jsx(STooltip, {
                size: "xs",
                placement: isFirst ? "top-start" : isLast ? "top-end" : "top",
                content: typeof value !== "string" ? label : label || value,
                children: /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                    ref: ref,
                    onClick: ()=>onClick(value),
                    $selection: selection,
                    children: typeof icon === "function" ? icon({
                        value
                    }) : icon
                })
            }),
            !showTooltip && /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                ref: ref,
                onClick: ()=>onClick(value),
                $selection: selection,
                children: typeof icon === "function" ? icon({
                    value
                }) : icon
            })
        ]
    });
};
export default PropertyButton;
const CSSEnumButtons = ({ selectedOption, orderedOptions, onSelectOption, props })=>{
    console.log(`CSSEnumButtons - orderedOptions`, orderedOptions, selectedOption);
    return /*#__PURE__*/ _jsx(SFlex, {
        grow: "1",
        direction: "row",
        gap: "1",
        children: orderedOptions.map(({ value, label, icon })=>{
            const shouldShowSelection = value === selectedOption;
            const highlightColor = getHighlightColor({
                isDynamic: props.isDynamic,
                hasValue: !!selectedOption
            });
            console.log(`CSSEnumButtons - selection - ${selectedOption}`, highlightColor, value);
            return /*#__PURE__*/ _jsx(PropertyButton, {
                label: label,
                value: value,
                icon: icon,
                selection: shouldShowSelection ? (props === null || props === void 0 ? void 0 : props.isDynamic) ? "conditional" : "literal" : undefined,
                onClick: (clickedValue)=>{
                    if (props.readOnly) return;
                    console.log(`CSSEnumButtons - clickedValue`, clickedValue);
                    onSelectOption(clickedValue);
                }
            }, value);
        })
    });
};
